module.exports = __webpack_public_path__ + "img/6.74b82c84.jpg";